const deleteServiceTypes = {
  toastr: 'Tipo de Servicio eliminado',
  toastr1: ' eliminado con éxito'
};

export default deleteServiceTypes;
